import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { VwapPromiseService, PairVwap } from "shared/cubiq-services";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { BfxBaseBlotter } from "../bfx-base-blotter/bfx-base-blotter";
import { BfxBlotterOrders } from "../bfx-blotter-orders/bfx-blotter-orders";
import { BfxTradeBlotterComponent } from "../bfx-blotter-trade/bfx-trade-blotter.component";
import { BfxVwapService } from "./bfx-vwap.service";
import { LoggerService } from "@bfx/logger";
import { Vwap } from "shared/cubiq-services/mediator/IVwapService";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxVwapOrdersService extends BfxVwapService {
  constructor(protected vwapService: VwapPromiseService) {
    super(vwapService);
  }

  public getPairsVwap(selectedOrderIds, ndfMode: boolean = false): Promise<Vwap> {
    return new Promise((res) => {
      this.vwapService.getVwapForOrders(selectedOrderIds, ndfMode).then(
        (pairs) => {
          res(pairs);
        },
        (reason) => {
          logger.out.error("ERROR:reason BfxVwapOrdersService: ", reason);
        },
      );
    });
  }
}
